//#region src/components/UnsupportedBrowserPage/UnsupportedBrowserPage.module.css
var e = "_container_12p4j_1", t = "_content_12p4j_5", n = "_subtitle_12p4j_9", r = {
	container: e,
	content: t,
	subtitle: n
};
//#endregion
export { e as container, t as content, r as default, n as subtitle };
